export interface DailyTrend {
  day: string;
  calories: number;
}

export const weeklyTrend: DailyTrend[] = [
  { day: "周一", calories: 1820 },
  { day: "周二", calories: 1950 },
  { day: "周三", calories: 1680 },
  { day: "周四", calories: 2100 },
  { day: "周五", calories: 1780 },
  { day: "周六", calories: 2240 },
  { day: "周日", calories: 2050 },
];